// assets
import { SecurityScanOutlined } from '@ant-design/icons';
import Permissions from 'constants/Permissions';

const detector = {
    id: 'detector-group',
    title: 'Sensors',
    type: 'group',
    appModule: 'SENSORS',
    children: [
        {
            id: 'detector',
            title: 'Detectors',
            authority: Permissions.DetectorSection.Detector,
            type: 'item',
            url: 'detector',
            icon: SecurityScanOutlined,
        },
    ],
};
export default detector;
